import React, { useContext } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { FiLogOut } from "react-icons/fi";
import { AuthContext } from "./AuthContext";

function AccountNav() {
  const { logout } = useContext(AuthContext);
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate("/login", { replace: true });
  };

  return (
    <nav className="account-nav" aria-label="Account sections">
      <NavLink to="/orders">Orders</NavLink>
      <NavLink to="/customers">Customers</NavLink>
      <button type="button" onClick={handleLogout}><FiLogOut /> Sign out</button>
    </nav>
  );
}

export default AccountNav;
